// TypesPrestationsContent.js
import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table as AntTable,
  Popconfirm,
  notification,
  Select,
  Checkbox,
} from "antd";
import { DeleteFilled, ExportOutlined, SyncOutlined, SearchOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
//import { journauxComptableService } from '../Services/journauxComptableService';
//import { journauxComptableService } from '../Services/journauxComptableService';
import { PlanComptaService } from "../Services/PlanComptaService";
import { JournauxComptableService } from "../Services/JournauxComptableService";
const { Title } = Typography;
// Applique size="small" à tous les tableaux de cette page sans autre changement
const Table = ({ size = "small", ...props }) => <AntTable size={size} {...props} />;

const JournauxComptable = () => {
  const initialTableData = [];
  const initialNewPrestation = {
    codej: "",
    libelle: "",
    type: "",
    compte_rattache: "",
    datecreation: "",
    num_compte: "",
    adr_banque: "",
    bque_default: false,
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [planCompta, setPlanCompta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);

  const journauxComptableService = new JournauxComptableService();
  const planComptaService = new PlanComptaService();

  useEffect(() => {
    if (planCompta.length === 0) {
      planComptaService
        .getAllPlanCompta()
        .then((data) => {
          setPlanCompta(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des prestations :", error);
        });
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    journauxComptableService
      .getAllJournauxComptable() // Ajoutez les parenthèses pour appeler la fonction
      .then((data) => {
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleUpdate = async () => {
    try {
      if (selectedRowData) {
        await journauxComptableService.updateJournal(selectedRowData); // Utilise updatePrestation pour mettre à jour la prestation sélectionnée
        const updatedData =
          await journauxComptableService.getAllJournauxComptable();
        setTableData(updatedData);
        setSelectedRowData(null);
        notification.success({
          message: "Modification réussie",
          description: "La prestation a été modifié avec succès.",
        });
      }
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };
  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createJounal = async () => {
    try {
      // Utilisation du numéro de compte sélectionné dans newPrestation.compte_rattache
      newPrestation.compte_rattache =
        newPrestation.compte_rattache.split(" - ")[0];

      await journauxComptableService.addJournal(newPrestation); // Utilisation de newPrestation pour ajouter la nouvelle prestation
      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData =
        await journauxComptableService.getAllJournauxComptable();
      setTableData(updatedData);
      notification.success({
        message: "Ajout réussie",
        description: "Ajout Réussi",
      });
      setShowCreateForm(false); // Masquer le formulaire après l'ajout
    } catch (error) {
      notification.error({
        message: "erreur",
        description: " Erreur lors de la suppression",
      });
    }
  };
  // Ensuite, dans votre fonction handleSave, appelez la fonction createJounal :
  const handleSave = () => {
    createJounal();
    // Réinitialiser l'état ou effectuer d'autres actions si nécessaire
  };

  const handleDelete = async (codej) => {
    try {
      await journauxComptableService.deleteJournal(codej);
      // Suppression réussie, mettre à jour les données et notifier
      const updatedData =
        await journauxComptableService.getAllJournauxComptable();
      setTableData(updatedData);
      setSelectedRowData(null);
      notification.success({
        message: "Suppression réussie",
        description: "Suppression effectuée avec succès.",
      });
    } catch (error) {
      // Gérer les erreurs côté frontend
      console.error("Erreur lors de la suppression :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la suppression ",
      });
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record); // Mettre à jour les données de la ligne sélectionnée
    setShowCreateForm(false)
  };

  const handleNew = () => {
    setSelectedRowData(null); // Réinitialiser les données sélectionnées
    setShowCreateForm(true); // Afficher le formulaire de création lors du clic sur "Nouveau"
  };

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };

  const handleResetAll = async () => {
    try {
      const updatedData =
        await journauxComptableService.getAllJournauxComptable(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) { }
  };

  const handleExport = () => {
    const exportData = tableData.map((item) => ({
      Code: item.codej,
      Libellé: item.libelle,
      Type: item.type,
      Compte: item.compte_rattache,
      "Créer le": item.datecreation
        ? moment(item.datecreation).format("DD-MM-YYYY")
        : "", // Formate la date si elle existe
      "Créer par": item.create_by,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Prestations");

    XLSX.writeFile(workbook, "export_JournauxComptable.xlsx");
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "codej",
      key: "codej",
      className: "small-cell",
      align: "center",
      ellipsis: true,
      width: "10%",
      render: (text) => (
        <strong>{text}</strong>
      ),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      className: "small-cell",
      ellipsis: true,
      width: "30%",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      className: "small-cell",
      ellipsis: true,
      width: "15%",
      align: "center",
    },
    {
      title: "compte",
      dataIndex: "compte_rattache",
      key: "compte_rattache",
      className: "small-cell",
      ellipsis: true,
      width: "10%",
      align: "center",
    },
    {
      title: "Créer le",
      dataIndex: "datecreation",
      key: "datecreation",
      className: "small-cell",
      ellipsis: true,
      width: "10%",
      align: "center",
      render: (text) => text ? moment(text).format("DD/MM/YYYY") : "",
    },
    {
      title: "Créer par",
      dataIndex: "create_by",
      key: "create_by",
      className: "small-cell",
      ellipsis: true,
      width: "10%",
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",
      // className: 'custom-action-column'
      ellipsis: true,
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.codej)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col
                span={9}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                {/*  barre de recherche */}
                <Input
                  className="search-input-highlight"
                  placeholder="Rechercher..."
                  allowClear
                  prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                  style={{ width: 250 }}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={(e) => handleSearch(e.target.value)}
                />
              </Col>
              <Col
                span={15}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* Vos boutons d'export et d'actualisation */}
                <Space>
                  <Button
                    className="buttonExport"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  <Button className="buttonRefresh" onClick={handleResetAll} icon={<SyncOutlined />}>
                    Actualiser
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          <Table
            className="custom-header1-table compact-rows-table"
            bordered
            /* size='small' */ columns={columns}
            showSorterTooltip={false}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}

          />
        </Col>

        <Col xs={24} xl={6}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, marginLeft: "15px", color: "#ffffff" }}>
                    {" "}
                    Nouveau Journal
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="code journal">
                  <Input
                    placeholder="code..."
                    //value={newPrestation.designation_article}
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        codej: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="libelle journal">
                  <Input
                    placeholder="intitulé..."
                    // value={newPrestation.prix_unitaire} // Ajouter la valeur par défaut ici
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        libelle: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Type">
                  <Select
                    placeholder="Sélectionner le type"
                    onChange={(value) =>
                      setNewPrestation({ ...newPrestation, type: value })
                    }
                    showSearch
                    allowClear={true}  // Autorise la suppression de la sélection
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    <Select.Option value="CAISSE">CAISSE</Select.Option>
                    <Select.Option value="TRANSFERT">TRANSFERT</Select.Option>
                    <Select.Option value="ACHAT">ACHAT</Select.Option>
                    <Select.Option value="BANQUE">BANQUE</Select.Option>
                    <Select.Option value="COTISATION">COTISATION</Select.Option>
                    <Select.Option value="REPORT">REPORT</Select.Option>
                    <Select.Option value="RETENUE">RETENUE</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item label="Compte rattaché">
                  <Select
                    placeholder="Sélectionner un compte"
                    showSearch
                    allowClear={true}  // Autorise la suppression de la sélection
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) =>
                      setNewPrestation({
                        ...newPrestation,
                        compte_rattache: value,
                      })
                    }

                  >
                    {planCompta.map((compte) => (
                      <Select.Option
                        key={compte.id}
                        value={`${compte.compte} - ${compte.intitule}`}
                      >
                        {`${compte.compte} - ${compte.intitule}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                {newPrestation.type === "BANQUE" && ( // Vérifie si le type sélectionné est 'BANQUE'
                  <>
                    <Form.Item label="Numéro de compte">
                      <Input
                        placeholder="Numéro de compte..."
                        value={newPrestation.num_compte || ""}
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            num_compte: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="Adresse">
                      <Input
                        placeholder="Adresse..."
                        value={newPrestation.adr_banque || ""}
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            adr_banque: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item>
                      <Checkbox
                        checked={newPrestation.bque_default || false}
                        onChange={(e) =>
                          setNewPrestation({
                            ...newPrestation,
                            bque_default: e.target.checked,
                          })
                        }
                      >
                        Banque de virement par défaut
                      </Checkbox>
                    </Form.Item>
                  </>
                )}
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      onClick={() => setShowCreateForm(false)}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSave}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Enregistrer
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, color: "#ffffff" }}>
                    {" "}
                    Modification Journal
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="code journal">
                  <Input
                    placeholder="code..."
                    value={selectedRowData ? selectedRowData.codej : ""}
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        codej: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="libellé journal">
                  <Input
                    placeholder="intitulé..."
                    value={selectedRowData ? selectedRowData.libelle : ""}
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        libelle: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Type">
                  <Select
                    value={selectedRowData ? selectedRowData.type : ""}
                    placeholder="Sélectionner le type"
                    showSearch
                    allowClear={true}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) =>
                      setSelectedRowData({ ...selectedRowData, type: value })
                    }
                  >
                    <Select.Option value=""></Select.Option>
                    <Select.Option value="CAISSE">CAISSE</Select.Option>
                    <Select.Option value="AVANCE">AVANCE</Select.Option>
                    <Select.Option value="TRANSFERT">TRANSFERT</Select.Option>
                    <Select.Option value="ACHAT">ACHAT</Select.Option>
                    <Select.Option value="BANQUE">BANQUE</Select.Option>
                    <Select.Option value="COTISATION">COTISATION</Select.Option>
                    <Select.Option value="REPORT">REPORT</Select.Option>
                    <Select.Option value="RETENUE">RETENUE</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item label="Compte rattaché">
                  <Select
                    showSearch
                    allowClear={true}  // Autorise la suppression de la sélection
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    placeholder="Sélectionner un compte"
                    value={
                      selectedRowData?.compte_rattache
                        ? `${selectedRowData.compte_rattache} - ${planCompta.find(
                          (compte) => compte.compte === selectedRowData.compte_rattache
                        )?.intitule || ''
                        }`
                        : undefined
                    }
                    onChange={(value) => {
                      // Gérer le cas où value est null lors d'un clear
                      if (!value) {
                        setSelectedRowData({
                          ...selectedRowData,
                          compte_rattache: null,  // Réinitialiser le champ
                        });
                        return;
                      }

                      // Si une valeur existe, on la traite
                      const selectedCompte = value.split(" - ")[0];
                      setSelectedRowData({
                        ...selectedRowData,
                        compte_rattache: selectedCompte,
                      });
                    }}
                  >
                    {planCompta.map((compte) => (
                      <Select.Option
                        key={compte.id}
                        value={`${compte.compte} - ${compte.intitule}`}
                      >
                        {`${compte.compte} - ${compte.intitule}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                {selectedRowData &&
                  selectedRowData.type === "BANQUE" && ( // Vérifie si le libellé est 'BANQUE'
                    <>
                      <Form.Item label="Numéro de compte">
                        <Input
                          placeholder="Numéro de compte..."
                          value={selectedRowData.num_compte || ""}
                          onChange={(e) =>
                            setSelectedRowData({
                              ...selectedRowData,
                              num_compte: e.target.value,
                            })
                          }
                        />
                      </Form.Item>
                      <Form.Item label="Adresse">
                        <Input
                          placeholder="Adresse..."
                          value={selectedRowData.adr_banque || ""}
                          onChange={(e) =>
                            setSelectedRowData({
                              ...selectedRowData,
                              adr_banque: e.target.value,
                            })
                          }
                        />
                      </Form.Item>
                      <Form.Item>
                        <Checkbox
                          checked={selectedRowData.bque_default} // Utilise directement la valeur de selectedRowData.bque_default (qui est soit true soit false)
                          onChange={(e) =>
                            setSelectedRowData({
                              ...selectedRowData,
                              bque_default: e.target.checked,
                            })
                          }
                        >
                          Banque de virement par défaut
                        </Checkbox>
                      </Form.Item>
                    </>
                  )}
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleNew}
                      style={{
                        backgroundColor: "transparent",
                        color: "#010f1c",
                        borderColor: "#010f1c",
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      onClick={handleUpdate}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Modifier
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default JournauxComptable;
